export default "__VITE_ASSET__ExsU61j3__"